var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeter = function SvgMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 12",
    fill: "#5E6D7A",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 3,
    height: 12,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 3,
    height: 12,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 3,
    height: 12,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 3,
    height: 12,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    width: 3,
    height: 12,
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 3,
    height: 12,
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 3,
    height: 12,
    rx: 1
  })));
};
export default SvgMeter;